/**
 * @format
 * @flow
 */
import React from 'react';

// import * as RT from '../../constants/Routing'
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import Modal from '../../components/Common/Modal';
import Loading from '../../components/Common/Loading';
import * as Actions from '../../actions/Auth';
import Logo1x from '../../assets/images/logo-square.png';
import Logo2x from '../../assets/images/logo-square@2x.png';
import FooterLinks from '../../components/Auth/FooterLink';
import * as RT from '../../constants/Routing';
import * as CONST from '../../constants/Const';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      formErrors: { email: '' },
      emailValid: false,
      formValid: false
    };
  }

  componentDidMount = () => {
    this.props.resetError();
    this.props.User.isLoggedIn = !!localStorage.getItem('logged_in');
    this.props.User.isSignedUp = !!localStorage.getItem('signed_up');
    const currentUser = localStorage.getItem('current_user');
    if (this.props.User.isLoggedIn && this.props.User.isSignedUp && currentUser) {
      this.props.history.push(RT.TOP_PATH);
    }
  };

  _signUp = e => {
    // this.props.history.push(RT.TASK_NEW_PATH)
    e.preventDefault();
    this.props.signUp(this.state.email);
  };

  _setEmail = e => {
    const { name } = e.target;
    const { value } = e.target;
    this.setState({ [name]: value }, () => {
      this._validateField(name, value);
    });
  };

  _validateField = (fieldName, value) => {
    // eslint-disable-next-line react/destructuring-assignment
    const { formErrors } = this.state;
    let { emailValid } = this.state;
    switch (fieldName) {
      case 'email':
        emailValid = value.match(CONST.EMAIL_TEMPLATE);
        formErrors.email = emailValid ? '' : CONST.INVALID_EMAIL;
        break;
      default:
        break;
    }
    this.setState({ formErrors, emailValid }, this.validateForm);
  };

  validateForm() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ formValid: this.state.emailValid });
  }

  _errorClass = error => {
    return error.length === 0 ? '' : 'has-error';
  };

  _moveToLogin = () => {
    localStorage.setItem('signed_up', true);
    // eslint-disable-next-line react/destructuring-assignment
    this.props.modalCloseInAuth();
    // eslint-disable-next-line react/destructuring-assignment
    // this.props.history.push(RT.SIGN_IN_PATH);
    this.props.history.push(RT.PASSWORD_REGISTRATION_PATH);
  };

  _CloseError = () => {
    this.props.modalErrorClose();
  };

  render = () => {
    return (
      <div className="">
        <Loading isOpen={this.props.App.loading} />
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle="パスワードを発行しました"
          okClickHandler={this._moveToLogin}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>

        <Modal
          isOpen={this.props.App.errorShow}
          headerTitle="Error"
          okClickHandler={this._CloseError}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.errMsg}
        </Modal>
        <div className="bg-block">
          <div className="auth-box">
            <form>
              <div className="auth-img-block">
                <img
                  src={Logo1x}
                  srcSet={`${Logo1x} 1x,${Logo2x} 2x`}
                  alt=""
                  className=""
                />
              </div>
              <div className="form-group position-relative">
                <label htmlFor="exampleInputEmail1">メールアドレス</label>
                <input
                  name="email"
                  type="email"
                  onChange={this._setEmail}
                  className={`form-control ${this._errorClass(this.state.formErrors.email)}`}
                  id="exampleInputEmail1"
                  placeholder="E-Mail"
                />
                <small className="text-muted">メールアドレスを入力してください</small>
                <label className="error_text">{this.state.formErrors.email}</label>
              </div>
              <div className="form-group position-relative link">
                <Link to={RT.SIGN_IN_PATH} className="">
                  ログインはこちら
                  </Link>
                <Link to={RT.PASSWORD_RESET_PATH} className="">
                  パスワードを忘れた方はこちら
                  </Link>
              </div>
              <div className="auth-button-block">
                <button
                  onClick={this._signUp}
                  type="submit"
                  className="btn btn-primary"
                  disabled={!this.state.formValid}
                >
                  仮パスワード発行
                  </button>
              </div>
            </form>
            <FooterLinks />
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
